import { render, staticRenderFns } from "./evaluate_score_count.vue?vue&type=template&id=0c270ae3&scoped=true&"
import script from "./evaluate_score_count.vue?vue&type=script&lang=js&"
export * from "./evaluate_score_count.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c270ae3",
  null
  
)

export default component.exports